module.exports = __webpack_public_path__ + "img/cog.da169255.svg";